package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.data.VerseEntity
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.utils.MyStringUtils
import com.eladfinish.bible.contest.utils.RegexUtils
import io.github.aakira.napier.Napier
import kotlinx.coroutines.Dispatchers

class SortVersesFullBookUseCase(
    private val assetReader: AssetReader,
    private val buildVerseEntitiesFromChapterUseCase: BuildVerseEntitiesFromChapterUseCase,
) {

    suspend operator fun invoke(
        bookNumber: Int,
    ): MutableList<VerseEntity> {
        val verseEntities = mutableListOf<VerseEntity>()
        val numOfChapters = BooksRepository.numOfChaptersPerBook[bookNumber - 1]
        val bookNameEnglish = BooksRepository.bookNamesEnglish[bookNumber - 1]
        val bookNameHebrew = BooksRepository.bookNamesHebrew[bookNumber - 1]
        Napier.d("bookNumber: $bookNumber")
        for (chapterNum in 1..numOfChapters) {
            val paddedNum = ChaptersRepository.padNumber(bookNameEnglish, chapterNum)
            val filename = ChaptersRepository.getFileFormat(
                number = bookNumber, bookName = bookNameEnglish, chapter = paddedNum
            )
            Napier.d("filename: $filename")
            val chapterContent = assetReader.readFile(fileName = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filename)
            val onlyContent = RegexUtils.getOnlyContent(chapterContent)
            val isFromSifreyEmet = MyStringUtils.isFromSifreyEmet(bookNameHebrew)
            val verseEntitiesOfChapter = buildVerseEntitiesFromChapterUseCase(
                coroutineContext = Dispatchers.Default,
                bookNumber = bookNumber,
                chapterNumber = chapterNum,
                chapterContent = onlyContent,
                isFromSifreyEmet = isFromSifreyEmet,
            )
            verseEntities.addAll(verseEntitiesOfChapter)
        }
        return verseEntities
    }

}
